module.exports = __webpack_public_path__ + "static/media/icon-facebook.2e47a020.svg";